import { PartyType } from '@parties/src/types';
import { InferType, object, string } from 'yup';
import i18n from '../../../../i18n';
import { addressSchema } from '../../../design-system/src';

export const AnvaPartyLegalSchema = object({
  name: string()
    .min(1, i18n.t('FIELD-LENGTH-ERROR', { n: 1 }))
    .required('REQUIRED_FIELD'),
  address: addressSchema.required('REQUIRED_FIELD'),
  legal_form: string().nullable().required('REQUIRED_FIELD'),
  company_registration: object({
    nr: string().nullable().required('REQUIRED_FIELD'),
  })
    .nullable()
    .required('REQUIRED_FIELD'),
});

export const AnvaPartyCustomerSchema = object({
  infix: string()
    .nullable()
    .test(
      'min-length-or-blank',
      i18n.t('FIELD-LENGTH-ERROR', { n: 2 }),
      (value) => !value || value.length >= 2,
    ),
  initials: string()
    .nullable()
    .test(
      'min-length-or-blank',
      i18n.t('FIELD-LENGTH-ERROR', { n: 2 }),
      (value) => !value || value.length >= 2,
    )
    .required('REQUIRED_FIELD'),
  last_name: string()
    .min(2, i18n.t('FIELD-LENGTH-ERROR', { n: 2 }))
    .required('REQUIRED_FIELD'),
  address: addressSchema.required('REQUIRED_FIELD'),
});

export const AnvaPartyCreationSchema = object({
  type: string().oneOf(['CUSTOMER', 'COMPANY']).required('REQUIRED'),
  details: object().when('type', {
    is: 'COMPANY',
    then: AnvaPartyLegalSchema,
    otherwise: AnvaPartyCustomerSchema,
  }),
});

export type AnvaPartyCreationFormValuesDetails =
  | AnvaPartyCreationFormValuesCustomer
  | AnvaPartyCreationFormValuesLegal;

export type AnvaPartyCreationFormValues = {
  type: PartyType;
  details: AnvaPartyCreationFormValuesDetails;
};

export type AnvaPartyCreationFormValuesLegal = {
  type: PartyType;
  details: InferType<typeof AnvaPartyLegalSchema>;
};
export type AnvaPartyCreationFormValuesCustomer = {
  type: PartyType;
  details: InferType<typeof AnvaPartyCustomerSchema>;
};
